import { useEffect, useRef } from 'react';

type ClickOutsideCallback = (event: MouseEvent) => void;

export function useClickOutside(callback: ClickOutsideCallback): any {
    const ref = useRef<HTMLDivElement | null>(null);

    function handleClickOutside(event: MouseEvent): void {
        if (ref.current && !ref.current.contains(event.target as Node)) {
            callback(event);
        }
    }

    useEffect(() => {
        const handleMouseDown = (event: MouseEvent): void => handleClickOutside(event);

        document.addEventListener('mousedown', handleMouseDown);

        return (): void => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    return ref;
}
